const full = import.meta.glob(['../images/works/*.webp', '!**/*-600.webp'], {
  eager: true,
  import: 'default',
})
const small = import.meta.glob('../images/works/*-600.webp', {
  eager: true,
  import: 'default',
})

// 1200px and 600px WebP screenshots (600px variants made with `cwebp -resize 600 0`).
const shot = (name) => {
  const src = full[`../images/works/${name}.webp`]
  return {
    src,
    srcSet: `${small[`../images/works/${name}-600.webp`]} 600w, ${src} 1200w`,
  }
}

const gh = (repo) => `https://github.com/yeldynov/${repo}`

// `selected: true` puts a project on the home page, in this order.
// `client` names whose work it is; everything without it is my own build.
// `github` is omitted where the code is private.
const projects = [
  {
    title: 'Art Opening Minds',
    image: shot('aom'),
    description:
      'Learning platform for US colleges. I built most of the front end.',
    stack: 'Next.js, TypeScript, Xano, Clerk, Jest',
    link: 'https://artopeningminds.org',
    client: 'Two Tabs',
    selected: true,
  },
  {
    title: 'Gvozdi',
    image: shot('gvozdi'),
    description:
      'Calm companion for nail-board practice: guided timer, streaks and sync on iOS, Android and web.',
    stack: 'React Native, Expo, Clerk, Drizzle, Neon, PostHog',
    link: 'https://gvozdi.expo.app',
    github: gh('gvozdi'),
    selected: true,
  },
  {
    title: 'Roam',
    image: shot('roam'),
    description:
      'Airbnb-style app: describe a stay in plain English, book and pay with Stripe.',
    stack: 'React Native, Expo, NativeWind, Sanity, Clerk, Stripe, PostHog',
    link: 'https://appetize.io/app/b_b7zfddw7bswku4lj3xi77rd5ba',
    linkLabel: 'Try it in the browser',
    github: gh('roam'),
  },
  {
    title: 'Old Road',
    image: shot('tea-shop'),
    description:
      'Tea store with Stripe Checkout and stock that never oversells.',
    stack: 'Next.js 16, Drizzle, Neon Postgres, Better Auth, Stripe',
    link: 'https://tea-shop-coral.vercel.app',
    github: gh('tea-shop'),
    selected: true,
  },
  {
    title: 'Vertex',
    image: shot('vertex'),
    description:
      'Video courses where AI search jumps to the exact second a topic is taught.',
    stack: 'Next.js 16, Sanity, Gemini, Clerk, Zod, PostHog',
    link: 'https://vertex-delta-orpin.vercel.app',
    github: gh('vertex'),
    selected: true,
  },
  {
    title: 'Unilake',
    image: shot('unilake'),
    description:
      'Marketing site and docs for an open-source data analytics platform.',
    stack: 'Shared UI components, Sentry, Docker',
    link: 'https://www.unilake.com',
    github: gh('www.unilake'),
    client: 'Unilake',
    selected: true,
  },
  {
    title: 'Atelier',
    image: shot('atelier'),
    description: 'Fashion storefront with 11 collections, search and user accounts.',
    stack: 'Next.js, Better Auth, Drizzle, PostgreSQL',
    link: 'https://atelie-store-beta.vercel.app',
    github: gh('atelie-store'),
    selected: true,
  },
  {
    title: 'CarePulse',
    image: shot('carepulse'),
    description: 'Health care app for hospital facilities.',
    stack: 'Next.js, Appwrite, Twilio, Sentry, shadcn/ui',
    link: 'https://carepulse-tau-one.vercel.app',
    github: gh('carepulse'),
  },
  {
    title: 'Dashboard AI',
    image: shot('dashboard-ai'),
    description: 'Dashboard for an AI image management tool.',
    stack: 'Next.js, TypeScript, shadcn/ui, Tailwind CSS',
    link: 'https://dashboard-ai-pied.vercel.app',
    github: gh('dashboard-ai'),
  },
  {
    title: 'Reddit Clone',
    image: shot('reddit'),
    description: 'Reddit rebuilt on Firebase auth and data.',
    stack: 'Next.js, Firebase, Chakra UI',
    link: 'https://redditclone-tan.vercel.app',
    github: gh('reddit-clone'),
  },
  {
    title: 'Study Buddy',
    image: shot('study-buddy'),
    description: 'Language school site, a remaster of one of my earlier builds.',
    stack: 'Next.js 15, TypeScript, shadcn/ui, Tailwind CSS',
    link: 'https://study-buddy-two-ashen.vercel.app',
    github: gh('study-buddy-two'),
  },
  {
    title: 'Kanban Board',
    image: shot('canban'),
    description: 'Interactive kanban board with Zustand state.',
    stack: 'Next.js, Zustand, Tailwind CSS',
    link: 'https://canban-zustand.vercel.app',
    github: gh('canban-zustand'),
  },
  {
    title: 'AI Summarizer',
    image: shot('summarizer'),
    description: 'Paste an article link and get a short summary from GPT-4.',
    stack: 'React, Redux Toolkit, OpenAI API',
    link: 'https://jazzy-cannoli-7f2982.netlify.app',
    github: gh('ai_summarizer'),
  },
  {
    title: 'Clothes Store',
    image: shot('ecommerce'),
    description: 'Headless clothing store on Wix CMS.',
    stack: 'Next.js, Wix CMS, Tailwind CSS',
    link: 'https://next-ecommerce-indol-pi.vercel.app',
    github: gh('next-ecommerce'),
  },
  {
    title: 'Evogym',
    image: shot('gym'),
    description: 'Gym landing page with motion and a working form.',
    stack: 'React, TypeScript, Framer Motion, React Hook Form',
    link: 'https://gym-landing-typescript.pages.dev',
    github: gh('gym-landing-typescript'),
  },
  {
    title: 'Alina Lee',
    image: shot('alina'),
    description: 'Portfolio site for a photographer and filmmaker.',
    stack: 'React, Framer Motion',
    link: 'https://wondrous-lolly-081cc0.netlify.app',
    github: gh('photographer-alina'),
    client: 'Alina Lee',
  },
]

export const selected = projects.filter((p) => p.selected)

export default projects
